<script setup>
  const { $html2pdf } = useNuxtApp()
  const props = defineProps({
    candidateFirstName: { required: true, type: String },
    candidateLastName: { required: true, type: String },
    speaker: { type: Object, default: null },
    employerName: { required: true, type: String },
    items: { required: true, type: Array } // [{ question, answer }]
  })

  const canGenerateLetter = () => {
    return props.items.some(item => item.answer)
  }

  const getGeneratedLetterPdf = async () => {
    const element = document.getElementById('generatedLetter')
    // clone the element: https://stackoverflow.com/questions/60557116/html2pdf-wont-print-hidden-div-after-unhiding-it/60558415#60558415
    const clonedElement = element.cloneNode(true)
    clonedElement.classList.remove('hidden')
    clonedElement.classList.add('block')

    // https://www.npmjs.com/package/html2pdf.js/v/0.9.0#options
    const blob = await $html2pdf().from(clonedElement).outputPdf('blob', 'my-invoice.pdf')
    clonedElement.remove()
    const pdf = new File([blob], `${props.candidateFirstName}-${props.candidateLastName}-motivation.pdf`, { type: 'application/pdf' })

    return pdf
  }
  defineExpose({ getGeneratedLetterPdf, canGenerateLetter })
</script>

<template>
  <div class="m-20 font-special" id="generatedLetter" hidden>
    <div class="grid grid-cols-2 grid-rows-2 text-2xl font-bold" id="header">
      <div class="col-start-1 row-start-1">
        <p>{{ props.candidateFirstName }} {{ props.candidateLastName }}</p>
      </div>
      <div class="col-start-2 row-start-2 ml-auto">
        <p v-if="props.speaker">{{ props.speaker.firstName }} {{ props.speaker.lastName }}</p>
        <p>{{ props.employerName }}</p>
      </div>
    </div>
    <div class="space-y-10 pt-20 font-bold" id="content">
      <p class="text-sm font-light">Lettre de motivation générée par la plateforme</p>
      <div class="space-y-5" v-for="(item, index) in props.items" :key="index">
        <p class="text-xl">{{ item.question }}</p>
        <p class="font-medium">{{ item.answer }}</p>
      </div>
      <div class="" id="footer">
        <p class="text-right text-2xl font-bold">{{ props.candidateFirstName }} {{ props.candidateLastName }}</p>
      </div>
    </div>
  </div>
</template>
